import styled from '@emotion/styled';
import { Tooltip, Typography } from 'antd';
import React from 'react';

interface ActionsColumnProps {
  value: any;
  width?: number;
}

export default React.memo((props: ActionsColumnProps) => {
  const { value, width } = props;
  return (
    <StyledContainer>
      <Tooltip title={value}>
        <a href={value || '#'} target={value ? '_blank' : '_self'} rel="noreferrer">
          <Typography.Text style={{ width: width || 300 }}>{value || '-'}</Typography.Text>
        </a>
      </Tooltip>
    </StyledContainer>
  );
});

const StyledContainer = styled.div`
  button.ant-btn {
    background: #eee;
    border-color: #eee;
  }
  .ant-typography {
    min-width: 300px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    line-height: 21px;
    max-height: 48px;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    color: #1890ff;
  }
`;
